import { render, staticRenderFns } from "./updateLink.vue?vue&type=template&id=5192c38a&scoped=true"
import script from "./updateLink.vue?vue&type=script&lang=js"
export * from "./updateLink.vue?vue&type=script&lang=js"
import style0 from "./updateLink.vue?vue&type=style&index=0&id=5192c38a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5192c38a",
  null
  
)

export default component.exports